import { EmbedFrame } from '../EmbedFrame';
import { isSafeEmbedUrl } from '../providers';

interface GenericEmbedProps {
  src?: string;
  url?: string;
  title?: string;
  ratio?: string;
}

/**
 * Fallback for deferred/unknown providers: a sandboxed iframe rendered only
 * when an explicit, http(s) source URL is present, so unrecognized embeds
 * degrade gracefully instead of breaking the page (or becoming an injection
 * vector via `javascript:`/`data:` URLs).
 */
export function GenericEmbed({ src, url, title, ratio }: GenericEmbedProps) {
  const source = src ?? url;
  if (!isSafeEmbedUrl(source)) return null;

  return (
    <EmbedFrame ratio={ratio}>
      <iframe
        className='h-full w-full border-0'
        src={source}
        title={title ?? 'Embedded content'}
        loading='lazy'
        referrerPolicy='strict-origin-when-cross-origin'
        sandbox='allow-scripts allow-popups allow-presentation'
        allowFullScreen
      />
    </EmbedFrame>
  );
}
